// Account fields the Trustline API does not store yet (company registration, VAT number, invoice email, billing plan).
// Kept in this browser, per signed-in email, until the backend has them.

export interface LocalAccount {
  vatNumber?: string;
  /** ISO 3166-1 alpha-2 code. */
  countryOfRegistration?: string;
  registrationNumber?: string;
  invoiceEmail?: string;
  plan?: string;
  /** When the plan was last changed (ms since epoch). */
  planChangedAt?: number;
}

const key = (email: string) => `trustline.account.${email.toLowerCase()}`;

export function readLocalAccount(email: string): LocalAccount {
  try {
    const raw = window.localStorage.getItem(key(email));
    return raw ? (JSON.parse(raw) as LocalAccount) : {};
  } catch {
    return {};
  }
}

export function writeLocalAccount(email: string, changes: Partial<LocalAccount>): LocalAccount {
  const next = { ...readLocalAccount(email), ...changes };
  try {
    window.localStorage.setItem(key(email), JSON.stringify(next));
  } catch {
    // Storage unavailable (private window, blocked site data): the values last for this page only.
  }
  return next;
}

export const LOCAL_ONLY_HINT = 'Saved in this browser until the Trustline API stores it.';
